var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Injectable } from '@angular/core';
import { SettingsProvider, SettingLifetime } from '../settings';
import { WorkspaceType } from '../workspace_enums';
import { UserProvider } from '../user';
var GridSettingsProvider = /** @class */ (function () {
    function GridSettingsProvider(settingsProvider, userProvider) {
        this.settingsProvider = settingsProvider;
        this.userProvider = userProvider;
    }
    GridSettingsProvider.prototype.getSettings = function (workspaceType) {
        var color = '#eea83b';
        var visible = false;
        var rows = 10;
        var columns = 10;
        switch (workspaceType) {
            case WorkspaceType.SceneRecognition:
                color = this.settingsProvider.get('scenerecognition.workspace.grid.color');
                visible = this.settingsProvider.get('scenerecognition.workspace.grid.visible');
                rows = this.settingsProvider.get('scenerecognition.workspace.grid.rows');
                columns = this.settingsProvider.get('scenerecognition.workspace.grid.columns');
                break;
            case WorkspaceType.AnomalyRecognition:
                color = this.settingsProvider.get('anomalyrecognition.workspace.grid.color');
                visible = this.settingsProvider.get('anomalyrecognition.workspace.grid.visible');
                rows = this.settingsProvider.get('anomalyrecognition.workspace.grid.rows');
                columns = this.settingsProvider.get('anomalyrecognition.workspace.grid.columns');
                break;
            case WorkspaceType.ObjectDetection:
                if (this.userProvider.hasDetectionBrainsCapability()) {
                    color = this.settingsProvider.get('detection.workspace.grid.color');
                    visible = this.settingsProvider.get('detection.workspace.grid.visible');
                    rows = this.settingsProvider.get('detection.workspace.grid.rows');
                    columns = this.settingsProvider.get('detection.workspace.grid.columns');
                }
                break;
            default:
                throw new Error("Invalid workspace type: " + workspaceType);
        }
        return {
            color: color,
            visible: visible,
            rows: rows,
            columns: columns
        };
    };
    GridSettingsProvider.prototype.persistSettings = function (workspaceType, state) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = workspaceType;
                        switch (_a) {
                            case WorkspaceType.SceneRecognition: return [3 /*break*/, 1];
                            case WorkspaceType.AnomalyRecognition: return [3 /*break*/, 3];
                            case WorkspaceType.ObjectDetection: return [3 /*break*/, 5];
                        }
                        return [3 /*break*/, 8];
                    case 1: return [4 /*yield*/, this.settingsProvider.setAll({
                            'scenerecognition.workspace.grid.color': state.color,
                            'scenerecognition.workspace.grid.visible': state.visible,
                            'scenerecognition.workspace.grid.rows': state.rows,
                            'scenerecognition.workspace.grid.columns': state.columns
                        }, SettingLifetime.Session)];
                    case 2:
                        _b.sent();
                        return [3 /*break*/, 9];
                    case 3: return [4 /*yield*/, this.settingsProvider.setAll({
                            'anomalyrecognition.workspace.grid.color': state.color,
                            'anomalyrecognition.workspace.grid.visible': state.visible,
                            'anomalyrecognition.workspace.grid.rows': state.rows,
                            'anomalyrecognition.workspace.grid.columns': state.columns
                        }, SettingLifetime.Session)];
                    case 4:
                        _b.sent();
                        return [3 /*break*/, 9];
                    case 5:
                        if (!this.userProvider.hasDetectionBrainsCapability()) return [3 /*break*/, 7];
                        return [4 /*yield*/, this.settingsProvider.setAll({
                                'detection.workspace.grid.color': state.color,
                                'detection.workspace.grid.visible': state.visible,
                                'detection.workspace.grid.rows': state.rows,
                                'detection.workspace.grid.columns': state.columns
                            }, SettingLifetime.Session)];
                    case 6:
                        _b.sent();
                        _b.label = 7;
                    case 7: return [3 /*break*/, 9];
                    case 8: return [2 /*return*/];
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    GridSettingsProvider = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [SettingsProvider, UserProvider])
    ], GridSettingsProvider);
    return GridSettingsProvider;
}());
export { GridSettingsProvider };
//# sourceMappingURL=grid-settings.js.map


// WEBPACK FOOTER //
// ./src/providers/workspace/grid-settings.ts.pre-build-optimizer.js